import { Divider, Flex, Text } from "@mantine/core";
import { type ISummaryItem } from "src/pages/Summary/Summary.types";
import {
  renderAuditName,
  renderStatusBadge,
} from "src/pages/Summary/Summary.utils";
import { useSelector } from "src/redux/hooks";
import { StyledTd } from "src/styled";

import { type MouseEventHandler } from "react";
import ReviewStatus from "./ReviewStatus";

interface Props {
  review: ISummaryItem;
  singleCell?: boolean;
  onClick?: () => void;
  red?: boolean;
}

const StatusCell = ({ review, singleCell, onClick, red }: Props) => {
  const uppercase = useSelector(state => state.preferencesSlice.uppercase);
  return (
    <StyledTd
      onClick={() => onClick?.()}
      center
      red={red}
      withoutImportant={singleCell !== undefined ? !singleCell : true}
      style={{ borderRight: "none" }}>
      {/*{renderReviewStatus(review.status, review.rstatus)}*/}
      <ReviewStatus rStatus={review.rstatus} status={review.status} />
      {review.status === 99 && review.reason ? (
        <Text color="gray.7" transform={uppercase ? "uppercase" : "none"}>
          {review.reason}
        </Text>
      ) : null}
      {review.auditman && review.auditman.length > 0 && (
        <>
          <Divider color="main.4" my={8} />
          {review.auditman.map((auditman, index) => (
            <div key={index}>
              <Flex justify="center" align="center" gap={5}>
                {auditman.status && renderStatusBadge(auditman.status)}
                <Text>{renderAuditName(auditman.status)}</Text>
              </Flex>
              <Text>{`${auditman.role ? `${auditman.role} - ` : ""}${
                auditman.name
              }`}</Text>
              <Text>{auditman.date}</Text>

              {index + 1 !== review.auditman?.length && (
                <Divider color="main.4" my={8} />
              )}
            </div>
          ))}
        </>
      )}
      {/* {review.rhist.length > 0 && ( */}
      {/*   <Flex gap={8} mt={8} justify="center"> */}
      {/*     {review.rhist.map((hist, index) => ( */}
      {/*       <StatusGoldCircle key={index}>{hist}</StatusGoldCircle> */}
      {/*     ))} */}
      {/*   </Flex> */}
      {/* )} */}
    </StyledTd>
  );
};

export default StatusCell;
